import {Header} from "../components/Header";
import ChevronUpIcon from "@heroicons/react/16/solid/ChevronUpIcon";
import { useEffect } from "react";

export const Chapter5 = () => {
  // Scroll to Top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    // Scroll to top when the page is rendered
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Header />
      <div className="mt-16 mb-10 px-4 sm:px-8 md:px-12 lg:px-20 xl:px-40 max-w-screen-lg md:w-[1300px] text-justify mx-auto ">
        <h1 className="text-center text-xl sm:text-2xl md:text-3xl underline md:mt-[120px]">
          जोगळेकर कुलवृत्तान्त समितीची वाटचाल
        </h1>
        <h3 className="text-center text-md mt-5 sm:text-2xl md:text-2xl">
          नमस्कार.
        </h3>
        <div  className="mt-5 text-lg sm:text-xl font-custom-regular ">
          <h3 className="font-custom-semi-bold text-xl text-center">पूर्वरंग</h3>
          <p className="mb-5 leading-relaxed mt-3 ">
            <span className="pl-6 sm:pl-8">१९३६-३७ </span>साली मुंबई स्थित श्री जयराम लक्ष्मण यांनी
            कुलवृत्तांत तयार करण्याचा प्रयत्न केला. त्या नंतर १९६० च्या सुमारास,
            बेळगावचे श्री. रघूनाथ कृष्ण आणि मुंबईचे श्री. विष्णू रघुनाथ यांनी
            दुसरा प्रयत्न केला. पहिले दोन्ही प्रयत्न का यशस्वी होऊ शकले नाहीत
            याची कारणे काय असावीत, याचा विचार करणें आता श्रेयस्कर होणार नाही.
          </p>
          <p>
            <span>१२ मे १९९१ </span> रोजी पुण्यातील श्री. विकास नारायण आणि श्री.
            श्रीधर राम या दोघांनी भिकारदास मारुती मंदिरात एक बैठक बोलावली.
            जोगळेकर कुलवृत्तान्त तयार करण्याचा हा तिसरा प्रयत्न. या बैठकीस
            सुमारे २७ जोगळेकर उपस्थित होते. याच बैठकीत जोगळेकर कुलवृत्तान्त
            समितीची मुहूर्तमेढ रोवली गेली. मेजर जनरल (निवृत्त) प्रभाकर काशिनाथ
            यांची समितीचे पहिले अध्यक्ष म्हणून निवड करण्यात आली.
          </p>
          <p>
            <span>याच</span>बैठकीत अस्थायी मध्यवर्ती कार्यकारिणीची देखील निवड
            करण्यात आली. जोगळेकर सदस्यांची माहिती संकलित करण्यासाठी एक फॉर्म
            तयार करण्यात आला.{" "}
          </p>
        </div>
        <div className="mt-5 text-lg sm:text-xl font-SOHNE_REGULAR ">
          <h3 className="font-semibold text-xl text-center">औदार्य आणि मदतीचा वारसा </h3>
          <p className="mb-5 leading-relaxed mt-3 ">
            <span className="pl-6 sm:pl-8">जून </span>1996 मध्ये, जोगळेकर कुटुंबाचा समृद्ध वारसा जतन
            करण्याच्या हेतूने ‘ जोगळेकर कुलवृत्तांत समिती’ची स्थापना एक
            सार्वजनिक धर्मादाय ट्रस्ट म्हणून करण्यात आली. या कामासाठी दूरदर्शी
            व्यक्तींचा एक गट एकत्र आला. गेल्या अडीच दशकांमध्ये, समितीने औदार्य,
            समर्पण आणि समाजाप्रती बांधिलकी दर्शविणारा एक उल्लेखनीय प्रवास
            यशस्वीरीत्या सुरू केला आहे.
          </p>
        </div>
        <div className="mt-5 text-lg sm:text-xl font-SOHNE_REGULAR ">
          <h3 className="font-semibold text-xl text-center">आरंभीची वर्षे (1996-2000)</h3>
          <p className="mb-5 leading-relaxed mt-3 ">
            <span  className="pl-6 sm:pl-8">समितीची</span>स्थापना संस्थापक सदस्यांच्या उत्स्फूर्त
            प्रयत्नामुळे झाली, ज्यांनी जोगळेकर कुटुंबातील सदस्यांना जोडण्यासाठी,
            एकत्र आणण्यासाठी आणि त्यांचा वारसा जतन करण्यासाठी एक व्यासपीठ तयार
            करण्याचा प्रयत्न केला. सुरुवातीच्या वर्षांत, समितीने त्याच्या
            पायाभूत सुविधा निर्माण करण्यावर, प्रशासकीय मंडळाची स्थापना करण्यावर
            आणि त्याची उद्दिष्टे निश्चित करण्यावर लक्ष केंद्रित केले.
          </p>
        </div>
        <div className="mt-5 text-lg sm:text-xl font-SOHNE_REGULAR ">
          <h3 className="font-semibold text-xl text-center">देणगी आणि परोपकार (2000-2010)</h3>
          <p className="mb-5 leading-relaxed mt-3 ">
            <span  className="pl-6 sm:pl-8">जसजसा</span> विश्वास वाढला, तसतसे त्यांचे परोपकारी प्रयत्नही
            वाढले. जोगळेकर कुलवृत्तांत समितीने शिक्षण, आरोग्यसेवा,
            समाजकल्याणाच्या उपक्रमांसह विविध कारणांसाठी देणग्या देण्यास सुरुवात
            केली. समितीच्या उदारतेने इतरांना योगदान देण्यासाठी प्रेरित केले आणि
            लवकरच, ते गरजूंसाठी आशेचे किरण बनले.
          </p>
        </div>
        <div className="mt-5 text-lg sm:text-xl font-SOHNE_REGULAR ">
          <h3 className="font-semibold text-xl text-center">वंशावळी पुस्तक प्रकाशन (1999 आणि 2010)</h3>
          <p className="mb-5 leading-relaxed mt-3 ">
            <span  className="pl-6 sm:pl-8">जोगळेकर</span>कुटूंबाचा इतिहास आणि वंशपरंपरा सांगणाऱ्या
            सर्वसमावेशक वंशावळी पुस्तकाचे प्रकाशन हे समितीच्या सर्वात लक्षणीय
            यशांपैकी एक होते. या महत्त्वपूर्ण कार्यामध्ये कुटुंबातील सदस्यांसह
            विस्तृत संशोधन, पडताळणी आणि सहकार्य यांचा समावेश होता. तेव्हापासून
            ही पुस्तके जोगळेकर कुटूंबासाठी एक मौल्यवान प्रेरणा स्त्रोत बनले आहे.
          </p>
        </div>
        <div className="mt-5 text-lg sm:text-xl font-SOHNE_REGULAR ">
          <h3 className="font-semibold text-xl text-center">नवीन वाटा आणि उपक्रम (2010-सध्या)</h3>
          <p className="mb-5 leading-relaxed mt-3 ">
            <span className="pl-6 sm:pl-8">अलिकडच्या</span>वर्षांत जोगळेकर कुलवृत्तांत समितीने आपला आवाका
            आणि प्रभाव वाढवला आहे. जसे की समितीने
            <ul className=" px-20 ">
              <li>- पात्र विद्यार्थ्यांना शिष्यवृत्ती आणि शैक्षणिक मदत दिली</li>
              <li>
                - आरोग्य सेवा उपक्रम आणि वैद्यकीय संशोधन करणाऱ्या संस्थांना
                देणग्या दिल्या
              </li>
              <li>- सांस्कृतिक कार्यक्रम आणि सामुदायिक मेळावे आयोजित केले</li>
              <li>
               - सामाजिक कल्याण आणि विकासाला चालना देण्यासाठी इतर संस्थांसोबत
                सहकार्य केले
              </li>
            </ul>
          </p>
        </div>
        <div className="mt-5 text-lg sm:text-xl font-SOHNE_REGULAR ">
          <h3  className="font-semibold text-xl text-center">एक चिरस्थायी वारसा</h3>
          <p className="mb-5 leading-relaxed mt-3 ">
            <span  className="pl-6 sm:pl-8">जोगळेकर</span> कुलवृत्तांत समितीने भविष्याचा वेध घेतल्याने
            त्याचा परिणाम येणाऱ्या पिढ्यांना जाणवेल हे स्पष्ट आहे. परोपकार,
            शिक्षण आणि समुदाय उभारणीसाठी ट्रस्टच्या वचनबद्धतेने एक चिरस्थायी
            वारसा तयार केला आहे, जो जोगळेकर कुटुंबाला आणि त्याही पुढे प्रेरणा
            आणि उन्नती देत राहील.
          </p>
          <p>
            समितीच्या संस्थापकांच्या शब्दात सांगायचे तर "आमचा प्रवास केवळ आपला
            वारसा जपण्याचा नाही तर सर्वांसाठी एक चांगले भविष्य घडवण्याचा आहे.
            आम्ही जे काही मिळवले त्याचा आम्हाला अभिमान आहे आणि आम्ही आमचे दान
            आणि सेवा देण्याचे ध्येय पुढे चालू ठेवण्यास उत्सुक आहोत. "
          </p>
        </div>

        <div onClick={scrollToTop} className="flex items-end justify-end my-5">
          <ChevronUpIcon className="size-8 bg-orange-600 text-white rounded-full" />
        </div>
        <hr />
      </div>
    </div>
  );
};
